import { useState, useEffect } from "react";
import "./Payment.css";
import { FaEye, FaTrash, FaFileExport, FaFilter, FaTimes } from "react-icons/fa";
// import { User } from "lucide-react";
import axios from "axios";

const Payment = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentFilter, setCurrentFilter] = useState("");
  const [amount, setAmount] = useState("");
  const [walletType, setWalletType] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    name: "",
    orderType: "",
    particular: "",
    reload: "",
    payment: ""
  });
  const [isWithdrawPopupOpen, setIsWithdrawPopupOpen] = useState(false);
  const [selectedTotal, setSelectedTotal] = useState(null);

  const [transactions, setTransactions] = useState([]);


  const [paymentId, setPaymentId] = useState("");
  const [orderId, setOrderId] = useState("");

  const storedUserId = localStorage.getItem("userId");
  const userId = storedUserId ? parseInt(storedUserId, 10) : null;

  const handleOpen = () => setShowPopup(true);
  const handleClose = () => setShowPopup(false);



  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  const handleSubmit = async () => {
    if (!userId || !amount) {
      alert("Please fill all fields");
      return;
    }

    // 🔹 Step 1: Load SDK dynamically
    const res = await loadRazorpayScript();
    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    // 🔹 Step 2: Initialize Razorpay checkout
    const options = {
      key: "rzp_test_R6hte6Puir9RAR",
      amount: amount * 100, // in paise
      currency: "INR",
      name: "Maamaa's House",
      description: "Wallet Load",
      handler: async function (response) {
        console.log("Razorpay Success Response:", response);

        try {
          // Call your backend API
          const result = await axios.post(
            `https://backend.maamaas.com/subscription/wallet/addCash/self-loaded`,
            {},
            {
              params: {
                userId,
                amount,
                paymentId: response.razorpay_payment_id,
                orderId: response.razorpay_order_id || "ORDER_" + Date.now(),
              },
              headers: {
                accept: "*/*",
              },
            }
          );

          console.log("✅ Wallet Loaded:", result.data);
          alert("Wallet successfully loaded!");
          window.location.reload();
          handleClose();
        } catch (err) {
          console.error("❌ Error saving wallet in backend:", err);
          alert("Wallet load failed on server.");
        }
      },
      prefill: {
        name: "Test User",
        email: "test@example.com",
        contact: "8546551257",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };


  const tableHeaderStyle = {
    padding: "10px",
    backgroundColor: "rgb(177 93 198)",
    color: "white",
    textAlign: "center",
  };

  const tableCellStyle = {
    padding: "8px",
    textAlign: "center",
    border: "1px solid #ddd",
  };

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken"); // ✅ get auth token

    if (!userId) {
      console.error("User ID not found in localStorage");
      return;
    }

    axios
      .get(
        `https://backend.maamaas.com/subscription/wallet/user/transactions/${userId}`,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        }
      )
      .then((res) => {
        setTransactions(res.data); // assuming API returns an array
      })
      .catch((err) => {
        console.error("Error fetching transactions:", err);
      });
  }, []);


  // ✅ Format date to readable


  const [wallet, setWallet] = useState({
    totalBalance: 0,
    cashbackAmount: 0,
    companyLoadedAmount: 0,
    selfLoadedAmount: 0,
  });


  useEffect(() => {
    const userId = localStorage.getItem("userId"); // get userId from localStorage
    const token = localStorage.getItem("authToken"); // get auth token

    if (!userId) return;

    const fetchWallet = async () => {
      try {
        const response = await axios.get(
          `https://backend.maamaas.com/subscription/wallet/user/${userId}`,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          }
        );
        setWallet(response.data);
      } catch (error) {
        console.error("Error fetching wallet data:", error);
      }
    };

    fetchWallet();
  }, []);

  const isMobile = window.innerWidth <= 768;

  const rowsPerPage = 10;



  const closeModal = () => {
    setIsModalOpen(false);
  };


  const handleFilterChange = (event) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [currentFilter]: event.target.value,
    }));
  };

  const handleWithdrawRequest = (amount) => {
    alert(`Withdrawal request for ₹${amount} sent successfully!`);
    setIsWithdrawPopupOpen(false);
  };


  // Pagination calculations
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const totalPages = 10;

  // Modal styles
  const modalOverlayStyles = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  };

  const modalContentStyles = {
    position: "relative",
    background: "#fff",
    padding: "30px",
    borderRadius: "8px",
    maxWidth: "400px",
    margin: "auto",
    textAlign: "left",
  };

  return (
    <div>
      <div
        style={{
          marginTop: isMobile ? "-0px" : "5px",
          overflow: "auto",
          height: "556px",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <div className="row">
          <div className="col-lg-5th">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgb(177, 93, 198)",
                color: "#fff",
                padding: "14px 0px",
                borderRadius: "5px",
                marginTop: "30px",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "13px",
              }}
            >
              <span>Total Balance</span>
              <span style={{ marginLeft: "10px" }}>₹{wallet.totalBalance}</span>
            </div>
          </div>

          <div className="col-lg-5th">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgb(177, 93, 198)",
                color: "#fff",
                padding: "14px 0px",
                borderRadius: "5px",
                marginTop: "30px",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "13px",
              }}
            >
              <span>Cashback</span>
              <span style={{ marginLeft: "10px" }}>₹{wallet.cashbackAmount}</span>
            </div>
          </div>

          <div className="col-lg-5th">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "rgb(177, 93, 198)",
                color: "#fff",
                padding: "14px 0px",
                borderRadius: "5px",
                marginTop: "30px",
                fontWeight: "bold",
                fontSize: "13px",
                justifyContent: "center",
              }}
            >
              <span>Company</span>
              <span style={{ marginLeft: "10px" }}>₹{wallet.companyLoadedAmount}</span>
            </div>
          </div>

          <div className="col-lg-5th">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "rgb(177, 93, 198)",
                color: "#fff",
                padding: "14px 0px",
                borderRadius: "5px",
                marginTop: "30px",
                justifyContent: "center",
                fontWeight: "bold",
                fontSize: "13px",
              }}
            >
              <span>Self</span>
              <span style={{ marginLeft: "10px" }}>₹{wallet.selfLoadedAmount}</span>
            </div>
          </div>

          <div className="col-lg-5th">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "rgb(30 102 225)",
                color: "#fff",
                padding: "14px 0px",
                borderRadius: "5px",
                marginTop: "30px",
                justifyContent: "center",
                fontWeight: "bold",
                fontSize: "15px",
              }}
            >
              <button
                style={{
                  backgroundColor: "rgb(30 102 225)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontSize: "15px",
                  fontWeight: "bold",
                }}
                onClick={handleOpen}
              >
                Load Wallet
              </button>

              {showPopup && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    height: "100vh",
                    width: "100vw",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 999,
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "#fff",
                      padding: "30px 40px",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                      width: "300px",
                      position: "relative",
                      textAlign: "center",
                    }}
                  >
                    <button
                      onClick={handleClose}
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        background: "transparent",
                        border: "none",
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "#888",
                        cursor: "pointer",
                      }}
                      title="Close"
                    >
                      ×
                    </button>

                    <h3 style={{ color: "#333", marginBottom: "20px" }}>Enter Amount</h3>

                    {/* Wallet Type */}


                    {/* Amount */}
                    <input
                      type="number"
                      placeholder="Enter Amount"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        marginBottom: "20px",
                        fontSize: "16px",
                      }}
                    />



                    <button
                      onClick={handleSubmit}
                      style={{
                        backgroundColor: "rgb(177, 93, 198)",
                        color: "#fff",
                        padding: "10px 20px",
                        border: "none",
                        borderRadius: "8px",
                        fontSize: "16px",
                        cursor: "pointer",
                        transition: "background-color 0.3s",
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          style={{
            borderRadius: "10px",
            marginTop: "4px",
            padding: "20px",
          }}
          className="wallet-tale-data"
        >
          <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
            Wallet Transactions
          </h3>


          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th style={tableHeaderStyle}>S.No</th>
                <th style={tableHeaderStyle}>Date</th>
                <th style={tableHeaderStyle}>Transaction Type</th>
                <th style={tableHeaderStyle}>Amount</th>
                <th style={tableHeaderStyle}>Balance Type</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((row, index) => (
                <tr key={row.id || index}>
                  <td style={tableCellStyle}>{index + 1}</td>
                  <td style={tableCellStyle}>
                    {new Date(row.transactionTime).toLocaleString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </td>

                  <td style={tableCellStyle}>{row.transactionType}</td>
                  <td
                    style={{
                      ...tableCellStyle,
                      color: row.transactionType === "CREDIT" ? "green" : "red",
                      fontWeight: "bold",
                    }}
                  >
                    {row.transactionType === "CREDIT" ? `+₹${row.amount}` : `-₹${row.amount}`}
                  </td>

                  <td style={tableCellStyle}>{row.balanceType}</td>
                </tr>
              ))}
            </tbody>
          </table>


          {/* Modal */}
          {isModalOpen && (
            <div style={modalOverlayStyles}>
              <div style={modalContentStyles}>
                <FaTimes
                  onClick={closeModal}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    cursor: "pointer",
                    color: "#b15dc6",
                    fontSize: "20px"
                  }}
                />
                <h3 style={{ marginBottom: "10px", fontSize: "30px" }}>Transaction Description</h3>
                <p style={{ textAlign: "justify" }}>
                  This transaction was successfully processed. Please check your account for confirmation.
                  Ensure that the transaction ID is saved for your records. Contact support if you do not see
                  the amount reflected within 24 hours.
                </p>
              </div>
            </div>
          )}

          {/* Filter Popup */}
          {isPopupOpen && (
            <div
              style={{
                position: "fixed",
                marginTop: "-66px",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "#fff",
                padding: "20px",
                boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                borderRadius: "8px",
                zIndex: 1000,
                width: "300px",
                textAlign: "center",
                position: "relative",
              }}
            >
              <button
                onClick={() => setIsPopupOpen(false)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  background: "transparent",
                  border: "none",
                  fontSize: "18px",
                  cursor: "pointer",
                  color: "#333",
                }}
              >
                ✖
              </button>

              <h3>
                Filter by{" "}
                {currentFilter === "name"
                  ? "Name"
                  : currentFilter === "orderType"
                    ? "Order Type"
                    : currentFilter === "particular"
                      ? "Particular"
                      : currentFilter === "reload"
                        ? "Reload"
                        : "Payment"}
              </h3>

              <input
                type="text"
                placeholder={`Enter ${currentFilter}`}
                value={filters[currentFilter] || ""}
                onChange={handleFilterChange}
                style={{ width: "100%", padding: "8px", margin: "10px 0", borderRadius: "4px" }}
              />

              <button
                onClick={() => setIsPopupOpen(false)}
                style={{ padding: "8px 12px", background: "rgb(177 93 198)", color: "#fff", borderRadius: "4px", border: "none" }}
              >
                Apply
              </button>
            </div>
          )}

          {/* Withdrawal Popup */}
          {isWithdrawPopupOpen && (
            <div
              style={{
                marginTop: "-30px",
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "#fff",
                padding: "20px",
                boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                borderRadius: "8px",
                zIndex: 1000,
                width: "300px",
                textAlign: "center",
                position: "relative",
              }}
            >
              <button
                onClick={() => setIsWithdrawPopupOpen(false)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  background: "transparent",
                  border: "none",
                  fontSize: "18px",
                  cursor: "pointer",
                  color: "#333",
                }}
              >
                ✖
              </button>

              <h3>Request Withdrawal</h3>
              <p>Amount: <strong>{selectedTotal}</strong></p>

              <button
                onClick={() => handleWithdrawRequest(selectedTotal)}
                style={{
                  padding: "8px 12px",
                  background: "rgb(177 93 198)",
                  color: "#fff",
                  borderRadius: "4px",
                  border: "none",
                  marginTop: "10px",
                }}
              >
                Confirm Withdrawal
              </button>
            </div>
          )}
        </div>

        <div style={{ position: "fixed", bottom: "0px", left: "0px", height: '30px', width: "100%", backgroundColor: "white", color: "black", textAlign: "center", padding: "5px", fontWeight: "bold", fontSize: "14px", boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)", zIndex: "999" }}>
          @Envision Integrated Services Pvt Ltd - Empowering Your Future 🚀
        </div>
      </div>
    </div>
  );
};




export default Payment;